import clsx from 'clsx';
import styles from './field-set.styles.module.css';

interface FieldSetProps {
  children: React.ReactNode;
  className?: string;
}

export function FieldSet({ children, className }: FieldSetProps) {
  return <fieldset className={clsx(styles.fieldSet, className)}>{children}</fieldset>;
}
